export enum HeaderTokenEnum {
    NoToken = 'NoToken',
    Bearder = "Bearer"
}

export enum AuthStorageKey {
    jwt = 'jwt',
    jwt_refresh = 'jwt_refresh',
    jwt_token_type = 'jwt_token_type',
}

export interface IJWTPayload {
    accessToken: string;
    refreshToken: string;
    tokenType: "Bearer"
}

export interface IJWTPayloadCode {
    status: boolean
}

export interface IJWTPayloadDecoded {
    account: {
        id: string;
        name: string;
    },
    project: {
        id: string;
        name: string;
    },
    user: {
        id: string;
        email: string;
    },
    iat: number;
    exp: number;
}

export interface IAuthPayload {
    email: string,
    password: string,
}